import { render, staticRenderFns } from "./navigation-view.vue?vue&type=template&id=47cb45ce&"
import script from "./navigation-view.vue?vue&type=script&lang=js&"
export * from "./navigation-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports